module.exports = __webpack_public_path__ + "static/img/30018 (5).b772e5a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30018 (5).webp
// module id = e7Sq
// module chunks = 14